(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('#video-block .video').on( "click", function() {
  		console.log(this);
  		$(this).find('figure').hide();
	});
 
})();